import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import {
  LogService,
  PershingTranslationService,
} from '@pershing/pershing-core';
@Component({
  selector: 'nxi-session-timeout',
  templateUrl: './sessiontimeout-warning.component.html',
})
export class SessionTimeoutComponent {
  secondsLeft: number = 60;
  minutesleft: number = 1;
  interval;
  startTimer() {
    this.logService.info('timer starting in popup');
    this.interval = setInterval(() => {
      if (this.minutesleft > 0) {
        this.minutesleft--;
      }
      if (this.secondsLeft > 0) {
        this.secondsLeft--;
      } else {
        this.endSession();
      }
    }, 1000);
  }
  ngOnInit() {
    this.startTimer();
  }
  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logService: LogService,
    private translationService: PershingTranslationService
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-portalcomponents',
      'node_modules/@pershing/nxi-portalcomponents/lib'
    );
    dialogRef.disableClose = true;
  }
  continue() {
    this.logService.info('continue with session');
    clearInterval(this.interval);
    let timeoutEvent = new CustomEvent('timeoutEvent', {
      detail: {
        status: 'continue',
      },
    });
    document.dispatchEvent(timeoutEvent);
    // this.portalService.invokeKeepAlive().subscribe( data => console.log( ' I am here invokeKeepalive ', data));
    this.dialogRef.close('leave');
  }
  endSession() {
    this.logService.info('logout session');
    let timeoutEvent = new CustomEvent('timeoutEvent', {
      detail: {
        status: 'end',
      },
    });
    document.dispatchEvent(timeoutEvent);
    this.dialogRef.close('end');
    clearInterval(this.interval);
  }
}
